import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Master Harta Tetap',
    title_form: 'Form Harta Tetap',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Harta Tetap',
        href: '/adm/fin/master/harta-tetap',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'code_harta',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'nama_harta',
        label: 'Nama',
        sortable: true,
      },
      {
        key: 'kelompok',
        label: 'Kelompok',
        sortable: true,
      },
      {
        key: 'harga_beli',
        label: 'Harga Beli',
        sortable: true,
      },
      {
        key: 'nilai_residu',
        label: 'Residu',
        sortable: true,
      },
      {
        key: 'nilai_buku',
        label: 'Nilai Buku',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      nama_harta: '',
      id_kelompok_harta: '',
      tgl_beli: '',
      harga_beli: '',
      nilai_residu: '',
      umur_ekonomis: '',
      id_department: '',
      nilai_buku: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeHartaTetap(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchHartaTetap(context, params = null) {
    let result = await ApiGetRequest(`fin/harta-tetap`, params);
    return !result.error ? result.data.object : [];
  },

  async getAllHartaTetap({ commit }) {
    commit('changeHartaTetap', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/harta-tetap`);
    commit('changeHartaTetap', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListHartaTetap({ commit, state }) {
    commit('changeHartaTetap', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/harta-tetap`, params);
    commit('changeHartaTetap', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailHartaTetap({ commit }, payload = null) {
    commit('changeHartaTetap', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/harta-tetap/${payload.id}`);
    commit('changeHartaTetap', {
      loading: false,
    });

    if (!result.error) {
      commit('changeHartaTetap', {
        form: {
          ...result.data.object,
          tgl_beli: result.data.object.tgl_beli
            ? moment(result.data.object.tgl_beli).format('DD/MM/YYYY')
            : '',
          tgl_hitung: result.data.object.tgl_hitung
            ? moment(result.data.object.tgl_hitung).format('DD/MM/YYYY')
            : '',
        },
      });
    }

    return result.error ? false : true;
  },

  async createHartaTetap({ commit, state, dispatch }) {
    commit('changeHartaTetap', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/harta-tetap`, state.data.form);
    commit('changeHartaTetap', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateHartaTetap({ commit, state, dispatch }, payload = null) {
    commit('changeHartaTetap', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/harta-tetap/${payload.id}`,
      state.data.form
    );

    commit('changeHartaTetap', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteHartaTetap({ commit, dispatch }, payload = null) {
    commit('changeHartaTetap', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/harta-tetap/${payload.id}`);
    commit('changeHartaTetap', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
